export default __webpack_public_path__ + "static/media/300.952768df.jpg";